import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/jira-router';

export const customerPermissionsRedirect = ({ match }: RouteContext) => {
	const { projectKey } = match.params;

	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
	return <Redirect to={url} />;
};
